import clsx from "clsx";
import type { MessageProps } from "@/domains/chat/helpers/messageProps";
import Time from "@/domains/chat/components/chat/messages/parts/Time";

export default function ChatNativeMessage({ message, settings }: MessageProps) {
  const { showTime } = settings;

  return (
    <div className={clsx("w-full text-[#f3ebd0]")}>
      {showTime && <Time date={message.date} />} [N] {message.message.content}
    </div>
  );
}
